/**
 * Wishlist grid - fetches wishlist items from Swym and renders product grid.
 * Uses Shopify JSON API for product data.
 */
(function () {
  'use strict';

  var BATCH_SIZE = 5;
  var BATCH_DELAY_MS = 50;

  function getSwym() {
    return window._swat && typeof window._swat.fetchWrtEventTypeET === 'function' ? window._swat : null;
  }

  function fetchProductByUrl(productUrl) {
    if (!productUrl) return Promise.resolve(null);
    var path = productUrl.indexOf('http') === 0 ? new URL(productUrl).pathname : productUrl;
    var jsonUrl = path.replace(/\/?$/, '') + '.json';
        return fetch(jsonUrl)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) { return data && data.product ? data.product : data; })
      .catch(function () { return null; });
  }

  function getEventType(swat) {
    var et = swat.EventTypes;
    return (et && (et.addToWishlist != null ? et.addToWishlist : et.addedToWishlist)) || 1;
  }

  function getDefaultListId(swat, callback) {
    if (typeof swat.fetchLists !== 'function') {
      callback(null);
      return;
    }
    swat.fetchLists({
      callbackFn: function (lists) {
        callback(lists && lists[0] ? lists[0].lid : null);
      },
      errorFn: function () { callback(null); }
    });
  }

  function inferAvailable(productOrVariant) {
    if (productOrVariant == null) return false;
    if (productOrVariant.available != null) return productOrVariant.available;
    if ('inventory_quantity' in productOrVariant) {
      return (productOrVariant.inventory_quantity || 0) > 0;
    }
    return false;
  }

  function renderProductCard(item, product, removeLabel, addToCartLabel, selectVariantLabel, soldOutLabel) {
    if (!product) return '';
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var url = product.url || productUrlFromItem(item);
    var productHref = product && product.handle
      ? root + 'products/' + product.handle
      : (url.indexOf('http') === 0 ? root + new URL(url).pathname.replace(/^\/([a-z]{2}(-[a-z]{2})?\/)/, '').replace(/^\//, '') : root + url.replace(/^\//, ''));
    var title = product.title || '';
    var img = product.featured_image || (product.images && product.images[0]);
    var imgSrc = img ? (typeof img === 'string' ? img : img.src) : '';
    var variantId = item.epi || (product.variants && product.variants[0] ? product.variants[0].id : '');
    var productId = item.empi || product.id;
    var du = item.du || (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'products/' + product.handle : url);
    var available = inferAvailable(product);
    var variantTitle = '';
    var hasMultipleVariants = product.variants && product.variants.length > 1;
    var price = item.pr != null ? item.pr : null;

    if (product.variants && product.variants.length > 0) {
      var matchedVariant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(variantId)) {
          matchedVariant = product.variants[i];
          break;
        }
      }
      if (!matchedVariant) matchedVariant = product.variants[0];
      if (matchedVariant) {
        available = inferAvailable(matchedVariant);
        if (price == null) price = matchedVariant.price;
        if (matchedVariant.title && matchedVariant.title !== 'Default Title') {
          variantTitle = matchedVariant.title;
        }
      }
    }

    var priceDisplay = '';
    if (price != null) {
      var priceNum = typeof price === 'string' ? parseFloat(price) : Number(price);
      if (item.pr != null) {
        priceDisplay = formatMoney(priceNum);
      } else {
        priceDisplay = formatMoney(priceNum / 100);
      }
    }

    var actionButton = '';
    if (!available) {
      actionButton = '<span class="wishlist-grid__sold-out">' + escapeHtml(soldOutLabel) + '</span>';
    } else if (hasMultipleVariants) {
      actionButton = '<a href="' + productHref + '" class="wishlist-grid__select-variant">' + escapeHtml(selectVariantLabel) + ' &rsaquo;</a>';
    } else {
      actionButton = '<button type="button" class="wishlist-grid__atc button" data-variant-id="' + variantId + '">' + escapeHtml(addToCartLabel) + '</button>';
    }

    return (
      '<li class="wishlist-grid__item">' +
        '<button type="button" class="wishlist-grid__remove tap-area" data-epi="' + variantId + '" data-empi="' + productId + '" data-du="' + escapeHtml(du) + '" aria-label="' + escapeHtml(removeLabel) + '">' +
          '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<a href="' + productHref + '" class="wishlist-grid__link">' +
          (imgSrc ? '<img class="wishlist-grid__image" src="' + imgSrc.replace(/&/g, '&amp;') + '" alt="" loading="lazy" width="400" height="400">' : '') +
        '</a>' +
        '<div class="wishlist-grid__info">' +
          '<a href="' + productHref + '" class="wishlist-grid__title">' + escapeHtml(title) + '</a>' +
          (variantTitle ? '<span class="wishlist-grid__variant">' + escapeHtml(variantTitle) + '</span>' : '') +
          (priceDisplay ? '<span class="wishlist-grid__price">' + priceDisplay + '</span>' : '') +
          actionButton +
        '</div>' +
      '</li>'
    );
  }

  function productUrlFromItem(item) {
    if (!item.du) return '';
    return item.du.indexOf('http') === 0 ? item.du : (window.location.origin + (item.du.charAt(0) === '/' ? '' : '/') + item.du);
  }

  function escapeHtml(s) {
    if (!s) return '';
    var div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  function formatMoney(amount) {
    var n = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
    if (isNaN(n)) return '';
    var moneyFormat = window.SwymOverrideMoneyFormat || (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    return moneyFormat.replace('{{amount}}', n.toFixed(2)).replace('{{amount_no_decimals}}', Math.round(n));
  }

  var WishlistGrid = customElements.get('wishlist-grid');
  if (WishlistGrid) return;

  class WishlistGridElement extends HTMLElement {
    constructor() {
      super();
      this._listId = null;
      this._items = [];
      this._boundOnAdded = this._onAdded.bind(this);
      this._boundOnRemoved = this._onRemoved.bind(this);
    }

    connectedCallback() {
      var self = this;
      var loading = this.querySelector('.wishlist-grid__loading');
      var content = this.querySelector('.wishlist-grid__content');
      var empty = this.querySelector('.wishlist-grid__empty');
      var errorEl = this.querySelector('.wishlist-grid__error');
      var columns = parseInt(this.getAttribute('data-columns') || '4', 10);
      var emptyMessage = this.getAttribute('data-empty-message') || 'Your wishlist is empty.';
      var errorMessage = this.getAttribute('data-error-message') || 'Unable to load wishlist.';
      var removeLabel = this.getAttribute('data-remove-label') || 'Remove';
      var addToCartLabel = this.getAttribute('data-atc-label') || 'Add to cart';
      var selectVariantLabel = this.getAttribute('data-select-variant-label') || 'Select Variant';
      var soldOutLabel = this.getAttribute('data-sold-out-label') || 'Sold out';

      function showLoading(show) {
        loading.hidden = !show;
      }
      function showContent(show) {
        content.hidden = !show;
      }
      function showEmpty(show) {
        empty.hidden = !show;
        if (show) empty.innerHTML = '<p class="text-subdued">' + emptyMessage + '</p>';
      }
      function showError(show) {
        errorEl.hidden = !show;
        if (show) errorEl.innerHTML = '<p class="text-subdued">' + errorMessage + '</p>';
      }

      function loadItems(items, lid) {
        self._listId = lid;
        self._items = items || [];
        showLoading(false);
        if (self._items.length === 0) {
          showEmpty(true);
          showContent(false);
          return;
        }
        showEmpty(false);
        showError(false);
        self._loadProductsInBatches(self._items, content, columns, removeLabel, addToCartLabel, selectVariantLabel, soldOutLabel, function () {
          showContent(true);
          self._attachRemoveHandlers(content, removeLabel);
          self._attachAddToCartHandlers(content);
        });
      }

      // Store references for use by event handlers
      self._fetchFromSwym = fetchFromSwym;
      self._showEmpty = showEmpty;
      self._showContent = showContent;

      function fetchFromSwym(swat) {
        if (typeof swat.fetchLists === 'function') {
          swat.fetchLists({
            callbackFn: function (lists) {
              var lid = lists && lists[0] ? lists[0].lid : null;
              var allItems = [];
              var seen = {};
              (lists || []).forEach(function (list) {
                if (list.listcontents && list.listcontents.length) {
                  list.listcontents.forEach(function (item) {
                    var key = String(item.empi) + '_' + String(item.epi);
                    if (!seen[key]) {
                      seen[key] = true;
                      allItems.push(item);
                    }
                  });
                }
              });
              if (allItems.length > 0) {
                loadItems(allItems, lid);
              } else {
                var eventType = getEventType(swat);
                swat.fetchWrtEventTypeET(function (items) {
                  loadItems(items, lid);
                }, eventType);
              }
            },
            errorFn: function () {
              showLoading(false);
              showError(true);
            }
          });
        } else {
          var eventType = getEventType(swat);
          swat.fetchWrtEventTypeET(function (items) {
            loadItems(items, null);
          }, eventType);
        }
      }

      // Listen for external wishlist changes
      document.addEventListener('swym_added', self._boundOnAdded);
      document.addEventListener('swym_removed', self._boundOnRemoved);

      var swat = getSwym();
      if (swat) {
        fetchFromSwym(swat);
      } else {
        var startTime = Date.now();
        var checkInterval = setInterval(function () {
          var s = getSwym();
          if (s) {
            clearInterval(checkInterval);
            fetchFromSwym(s);
          } else if (Date.now() - startTime > 15000) {
            clearInterval(checkInterval);
            showLoading(false);
            showError(true);
          }
        }, 500);
      }

      setTimeout(function () {
        if (loading && !loading.hidden) {
          showLoading(false);
          showError(true);
        }
      }, 20000);
    }

    disconnectedCallback() {
      document.removeEventListener('swym_added', this._boundOnAdded);
      document.removeEventListener('swym_removed', this._boundOnRemoved);
    }

    _onAdded() {
      // Re-fetch and re-render the entire grid to show the newly added product
      var swat = getSwym();
      if (swat && this._fetchFromSwym) {
        this._fetchFromSwym(swat);
      }
    }

    _onRemoved(ev) {
      // Handle external removals (grid's own remove handler already manages its DOM)
      var detail = ev.detail && ev.detail.d;
      if (!detail || !detail.empi) return;
      var empi = String(detail.empi);
      var content = this.querySelector('.wishlist-grid__content');
      if (!content) return;
      var btn = content.querySelector('.wishlist-grid__remove[data-empi="' + empi + '"]');
      // Only remove if the element still exists (not already removed by grid's own handler)
      if (btn) {
        var li = btn.closest('.wishlist-grid__item');
        if (li) li.remove();
      }
      // Check if grid is now empty
      var list = content.querySelector('.wishlist-grid__list');
      if (list && list.children.length === 0 && this._showEmpty && this._showContent) {
        this._showEmpty(true);
        this._showContent(false);
      }
    }

    _loadProductsInBatches(items, container, columns, removeLabel, addToCartLabel, selectVariantLabel, soldOutLabel, done) {
      var self = this;
      var products = [];
      var index = 0;

      function processBatch() {
        var end = Math.min(index + BATCH_SIZE, items.length);
        var batch = items.slice(index, end);
        var promises = batch.map(function (item) {
          var url = productUrlFromItem(item);
          return fetchProductByUrl(url).then(function (product) {
            return { item: item, product: product };
          });
        });
        Promise.all(promises).then(function (results) {
          results.forEach(function (r) {
            products.push(r);
          });
          index = end;
          if (index < items.length) {
            setTimeout(processBatch, BATCH_DELAY_MS);
          } else {
            var html = '<ul class="wishlist-grid__list" style="--wishlist-columns: ' + columns + '">';
            products.forEach(function (p) {
              html += renderProductCard(p.item, p.product, removeLabel, addToCartLabel, selectVariantLabel, soldOutLabel);
            });
            html += '</ul>';
            container.innerHTML = html;
            done();
          }
        });
      }
      processBatch();
    }

    _attachRemoveHandlers(container, removeLabel) {
      var self = this;
      var swat = getSwym();
      if (!swat || typeof swat.deleteFromList !== 'function') return;
      var listId = self._listId;
      container.querySelectorAll('.wishlist-grid__remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var epi = parseInt(btn.getAttribute('data-epi'), 10);
          var empi = parseInt(btn.getAttribute('data-empi'), 10);
          var du = btn.getAttribute('data-du');
          if (!empi || !epi) return;

          // Only pass allowed fields - Swym rejects internal fields like di, cts, lid, pid, id, uts, _pkey, _t
          var allowedKeys = ['epi', 'empi', 'du', 'dt', 'bt', 'iu', 'pr', 'vi', 'qty', 'note', 'cprops', 'lbls', 'source', 'channel', 'sku', '_av', '_cv', '_fv', 'op', 'ct', 'idx'];
          var product = { epi: epi, empi: empi, du: du || '' };
          var itemLid = null;
          for (var j = 0; j < self._items.length; j++) {
            if (String(self._items[j].empi) === String(empi) && String(self._items[j].epi) === String(epi)) {
              var orig = self._items[j];
              itemLid = orig.lid;
              product = {};
              for (var k = 0; k < allowedKeys.length; k++) {
                if (orig[allowedKeys[k]] != null) product[allowedKeys[k]] = orig[allowedKeys[k]];
              }
              break;
            }
          }
          // Use the item's own lid (items can belong to different lists)
          var lid = itemLid || listId;
          if (!lid && window.SwymWrapper && window.SwymWrapper.fetchCustomerLists) {
            window.SwymWrapper.fetchCustomerLists(function (lists) {
              lid = lists && lists[0] ? lists[0].lid : null;
              if (lid) doRemove(lid);
            });
          } else if (lid) {
            doRemove(lid);
          }

          function doRemove(lid) {
            swat.deleteFromList(lid, product, function (res) {
              if (res && res.hasError) {
                document.dispatchEvent(new CustomEvent('toast:show', {
                  detail: { message: 'Error removing item', tone: 'error', duration: 2500 }
                }));
                return;
              }
              var li = btn.closest('.wishlist-grid__item');
              if (li) li.remove();
              // Remove from internal items array
              self._items = self._items.filter(function (it) {
                return !(String(it.empi) === String(empi) && String(it.epi) === String(epi));
              });
              var list = container.querySelector('.wishlist-grid__list');
              if (list && list.children.length === 0) {
                var empty = self.querySelector('.wishlist-grid__empty');
                if (empty) {
                  empty.hidden = false;
                  empty.innerHTML = '<p class="text-subdued">' + (self.getAttribute('data-empty-message') || 'Your wishlist is empty.') + '</p>';
                }
                container.hidden = true;
              }
            }, function () {
              var li = btn.closest('.wishlist-grid__item');
              if (li) li.style.opacity = '1';
              document.dispatchEvent(new CustomEvent('toast:show', {
                detail: { message: 'Error removing item', tone: 'error', duration: 2500 }
              }));
            });
          }
        });
      });
    }

    _attachAddToCartHandlers(container) {
      container.querySelectorAll('.wishlist-grid__atc').forEach(function (btn) {
        var originalLabel = btn.textContent;
        btn.addEventListener('click', function () {
          var variantId = btn.getAttribute('data-variant-id');
          if (!variantId) return;
          btn.disabled = true;
          btn.textContent = '...';
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
          }).then(function (res) {
            if (res.ok) {
              btn.textContent = '\u2713';
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              setTimeout(function () { btn.textContent = originalLabel; btn.disabled = false; }, 1500);
            } else {
              res.json().then(function (errData) {
                var msg = (errData && (errData.description || errData.message)) || 'Error';
                btn.textContent = msg;
                setTimeout(function () { btn.textContent = originalLabel; btn.disabled = false; }, 2500);
              }).catch(function () {
                btn.textContent = 'Error';
                setTimeout(function () { btn.textContent = originalLabel; btn.disabled = false; }, 2000);
              });
            }
          }).catch(function () {
            btn.textContent = 'Error';
            setTimeout(function () { btn.textContent = originalLabel; btn.disabled = false; }, 2000);
          });
        });
      });
    }
  }

  customElements.define('wishlist-grid', WishlistGridElement);
})();
